<script lang="ts" setup>
interface Props {
  modelValue: boolean
  disabled?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<Emits>()

const isOwnChassis = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <el-switch
    v-model="isOwnChassis"
    inline-prompt
    active-color="#13ce66"
    inactive-color="#ff4949"
    active-text="Own"
    inactive-text="Pool"
    :disabled="disabled"
  />
</template>
